import type { ModelWidgetOptions } from '../../types/ModelWidgetOptions';
import { shouldSendAPIRequest } from '../features/shouldSendAPIRequest';

import type { DataModel, ModelWidgetData } from './types';

export const getModelWidgetData = async (options: ModelWidgetOptions): Promise<ModelWidgetData> => {
  const model: DataModel = {
    widgetMissing: false,
    widgetChanged: false,
    reFetchData: false,
    tabConfigs: [],
    defaultTab: null,
    tabData: {},
    tabParams: {},
  };

  const {
    props: { widget, params, getWidgetResponse },
  } = options;

  if (!shouldSendAPIRequest(widget, params)) {
    return {
      options,
      model,
    };
  }

  return {
    options,
    model: {
      ...model,
      widgetResponse: await getWidgetResponse(params),
    },
  };
};
